module.exports = __webpack_public_path__ + "img/nodata_participated.50d969e8.png";